export enum LocalStorageKey {
  installationId = 'Installation-Id',
}
